module.exports = __webpack_public_path__ + "img/bluebot scruffy 100X200.fff02c26.jpg";